import React, { FunctionComponent } from 'react';
import { Tooltip } from '@nbc-design/tooltip';
import { getTextFactoryReturnType } from '../../../../../utils/TextUtils';

type InvestmentFirmEmployeeTooltipProps = {
  getText: getTextFactoryReturnType;
};

const InvestmentFirmEmployeeTooltip: FunctionComponent<InvestmentFirmEmployeeTooltipProps> = ({ getText }) => {
  return (
    <Tooltip
      id="hasNbfEmploymentTooltip"
      className="ml-2"
      position="bottom"
      content={
        <div>
          {getText('firmEmployeeQuestion.tooltip')}
          <br />
          <ul className="text-left">
            <li>{getText('firmEmployeeQuestion.tooltip.nbdb')}</li>
            <li>{getText('firmEmployeeQuestion.tooltip.nbfwm')}</li>
            <li>{getText('firmEmployeeQuestion.tooltip.nbcm')}</li>
            <li>{getText('firmEmployeeQuestion.tooltip.nbin')}</li>
            <li>{getText('firmEmployeeQuestion.tooltip.1859')}</li>
          </ul>
        </div>
      }
      iIcon={{ size: 'medium' }}
    />
  );
};

export default InvestmentFirmEmployeeTooltip;
